export default __webpack_public_path__ + "static/media/330_portfolio04-jp-web.e7e6a243.png";